const computeUpdatedPricesForProduct = (
  product,
  selectedOptions,
  getPriceForSelectedOptions
) => {
  const finalPriceInclTax = getPriceForSelectedOptions(
    product,
    selectedOptions,
    (prices) => prices?.finalPrice?.priceInclTax?.value?.amount
  );
  const finalPriceExclTax = getPriceForSelectedOptions(
    product,
    selectedOptions,
    (prices) => prices?.finalPrice?.priceExclTax?.value?.amount
  );
  const regularPriceInclTax = getPriceForSelectedOptions(
    product,
    selectedOptions,
    (prices) => prices?.regularPrice?.priceInclTax?.value?.amount
  );
  const regularPriceExclTax = getPriceForSelectedOptions(
    product,
    selectedOptions,
    (prices) => prices?.regularPrice?.priceExclTax?.value?.amount
  );

  const updatedPrices = {
    ...product.prices,
    finalPrice: {
      ...product.prices.finalPrice,
      priceInclTax: {
        ...product.prices.finalPrice.priceInclTax,
        value: {
          ...product.prices.finalPrice.priceInclTax.value,
          amount: finalPriceInclTax,
        },
      },
      priceExclTax: {
        ...product.prices.finalPrice.priceExclTax,
        value: {
          ...product.prices.finalPrice.priceExclTax.value,
          amount: finalPriceExclTax,
        },
      },
    },
    regularPrice: {
      ...product.prices.regularPrice,
      priceInclTax: {
        ...product.prices.regularPrice.priceInclTax,
        value: {
          ...product.prices.regularPrice.priceInclTax.value,
          amount: regularPriceInclTax,
        },
      },
      priceExclTax: {
        ...product.prices.regularPrice.priceExclTax,
        value: {
          ...product.prices.regularPrice.priceExclTax.value,
          amount: regularPriceExclTax,
        },
      },
    },
  };

  return updatedPrices;
};

export default computeUpdatedPricesForProduct;
